class MainHeader extends HTMLElement {
    constructor() {
        super();

        window.addEventListener('DOMContentLoaded', () => {
            function setHeaderMenuPosition() {

                if (document.querySelector('.header-wrapper .site-nav__item')) {
                    const rect = document.querySelector('.header-wrapper .site-nav__item').getBoundingClientRect();
                    if (document.querySelectorAll('.site-header__dropdown').length > 0) {
                        document.querySelectorAll('.site-header__dropdown').forEach(function (item) {
                            item.style.top = rect.y + rect.height + 9 + "px";
                        })
                    }
                }

                window.addEventListener('resize', () => {
                    if (document.querySelector('.site-header')) {
                        const siteHeaderRect = document.querySelector('.site-header').getBoundingClientRect();
                        if (document.querySelector('.drawer.drawer--on-top')) {
                            document.querySelector('.drawer.drawer--on-top').style.top = siteHeaderRect.y + siteHeaderRect.height + "px";
                        }
                    }
                });

            }

            document.addEventListener('scroll', function () {
                    setHeaderMenuPosition();
                }
            );

            setTimeout(function () {
                setHeaderMenuPosition();
            }, 500);

            this.querySelector('.site-nav__burger').addEventListener('click', () => {
                this.toggleMobileMenu()
            })
            this.toggleDropDown();

            document.querySelector('.main-content').addEventListener('click', () => {

                const mobileMenu = document.querySelector('#menuDropDown');
                if (mobileMenu.classList.contains('hide__mobile-menu')) {
                    this.toggleMobileMenu();
                }

            });


            const headerMenu = document.querySelectorAll('[data-header-menu]');

            headerMenu.forEach((head) => {
                head.addEventListener('mousemove', (ev) => {
                    const linkTitle = head.getAttribute('data-header-menu');
                    const imageItem = head.getAttribute('data-image-item')
                    const menuItem = head.getAttribute('data-menu-item')
                    const dropdown = document.querySelectorAll('.site-header__dropdown');

                    if (linkTitle === imageItem) {
                        dropdown.forEach((element) => {
                            if (element.classList.contains('menu-item__dropdown')) {
                                element.classList.remove('menu-item__dropdown')
                            }
                            element.classList.add('images__dropdown');
                        })

                    } else if (linkTitle === menuItem) {
                        dropdown.forEach((element) => {
                            if (element.classList.contains('images__dropdown')) {
                                element.classList.remove('images__dropdown')
                            }
                            element.classList.add('menu-item__dropdown');
                        })

                    }
                })
            })

            $('[data-dropdown-name]').hover(function () {
                const name = $(this).attr('data-dropdown-name');
                $(this).closest('.nav-dropdown__wrapper').find('[data-dropdown-items]').addClass('hide');
                $(`[data-dropdown-items="${name}"]`).removeClass('hide');
            });

        })
        ;
    }

    toggleDropDown() {
        const dropdownIcon = document.querySelectorAll('.mobile__menu--icon');

        dropdownIcon.forEach((icon) => {
            icon.addEventListener('click', () => {
                icon.classList.toggle('open__dropdown');
            })
        })
    }

    toggleMobileMenu() {

        const mobileMenu = document.querySelector('#menuDropDown');
        let body = document.querySelector("body");
        mobileMenu.classList.toggle('hide__mobile-menu');

        const header = document.querySelector('.header__grid').getBoundingClientRect()
        const top = header.height + header.y;

        mobileMenu.style.setProperty('top', `${top - 16}px`);

        mobileMenu.style.setProperty('height', `calc(100vh - ${top - 16}px)`);

        this.querySelector('.js-drawer-open-button-left').classList.toggle('open');

        if (mobileMenu.classList.contains('hide__mobile-menu')) {
            body.style.overflow = 'hidden';
            document.querySelector('.header__grid').style.setProperty('margin', '0')
            document.querySelector('.mobile__menu-links__block').style.setProperty('margin', '0')
        } else {
            body.style.overflow = 'auto';
            document.querySelector('.header__grid').style.setProperty('margin', '16px 16px 0')
            document.querySelector('.mobile__menu-links__block').style.setProperty('margin', '0 16px')
        }
    }

}

customElements.define('main-header', MainHeader);
